import { render, staticRenderFns } from "./AppSubheader.vue?vue&type=template&id=45268699&"
import script from "./AppSubheader.vue?vue&type=script&lang=ts&"
export * from "./AppSubheader.vue?vue&type=script&lang=ts&"
import style0 from "./AppSubheader.vue?vue&type=style&index=0&id=45268699&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports